import React from 'react'

const OptionsIcon = () => {
    return (


        <svg className='options-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.83 164.98">
            <path className="cls-1" d="M62.91,22.71h101.79" />
            <path className="cls-1" d="M5.12,22.71h22.61" />
            <path className="cls-1" d="M81.34,142.27h83.37" />
            <path className="cls-1" d="M5.12,142.27h41.04" />
            <path className="cls-2" d="M151.38,82.49h13.33" />
            <path className="cls-2" d="M5.12,82.49h111.08" />
            <circle className="cls-1" cx="45.33" cy="22.71" r="17.59" />
            <circle className="cls-2" cx="133.79" cy="82.49" r="17.59" />
            <circle className="cls-1" cx="63.75" cy="142.27" r="17.59" />
        </svg>
    )
}

export default OptionsIcon
